import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledFarmsPage = styled('div')`
  @media only screen and (min-width: ${breakpoints.lg}px) {
    table {
      width: 100% !important;

      .ant-table-thead {
        .ant-table-cell {
          white-space: nowrap !important;
        }
      }

      .ant-table-row {
        .ant-table-cell {
          padding: 8px 12px !important;
        }
      }
    }
  }
`;
